var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"img"},[_vm._l((_vm.urlList),function(item,index){return [_c('img',{key:index,attrs:{"src":item,"width":"100%"}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }